import { useState } from "react";
import { ArrowLeft, ArrowRight, Quote, Star } from "lucide-react";

import { Button } from "./ui/button";
import { Card, CardContent, CardHeader } from "./ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi,
} from "./ui/carousel";

const testimonials = [
  {
    name: "Kate Endresz",
    location: "Blackpool",
    quote:
      "I can only praise James! He was always on time to the minute, professional, helpful and all round a great guy. I would recommend him to anyone who needs a good electrician. He has since done work for my mum and she had the same positive experience!",
  },
  {
    name: "Joe George",
    location: "Blackpool",
    quote:
      "Excellent electrician, very professional, friendly, and reliable. Arrived on time, worked quickly, and left everything clean and tidy. The quality of work was spot on and clearly done with care and attention to detail. Highly recommend!",
  },
  {
    name: "Samantha Pearson",
    location: "Fylde Coast",
    quote:
      "James came out to a repair when we had faulty electrics following a storm. He was at the property just a few hours after I called and explained the problem in detail, getting the electrics back up and running despite having to stay late at night. Thank you James!",
  },
  {
    name: "Patrick Hitie",
    location: "Blackpool",
    quote:
      "James has been an absolute delight to deal with. No job is too small or too big. His quality of work is first-class, neat, and professional. Prices are very reasonable, and he's incredibly reliable. I highly recommend him for any electrical job!",
  },
  {
    name: "Martin Robinson",
    location: "Blackpool",
    quote:
      "James from EIM came round to fit some outside security lights. He arrived on time, was polite and professional throughout, and did a really tidy job. I'm very pleased with the work and would definitely recommend using James at EIM.",
  },
  {
    name: "Sherry Brooks",
    location: "Blackpool",
    quote:
      "James is very conscientious, efficient and thorough. He dropped everything and came straight to me when I had an emergency on a Saturday night. He genuinely cares about his reputation and his customers alike. A very easily earnt 5 stars.",
  },
  {
    name: "Finli Moffat",
    location: "Blackpool",
    quote:
      "James is a top lad, best electrician in Blackpool. Gets the job done quick and comes out when you need him. Definitely worth using. Anything in the house we need doing, give him a call and he will come out straight away and get it done.",
  },
  {
    name: "Deborah Ozturk",
    location: "Blackpool",
    quote:
      "Just had my house fully rewired by E.I.M Electrical Contractors. Absolutely cannot fault the team. Fully trained by their grandad and dad, the knowledge is second to none. I would highly recommend them to anyone.",
  },
  {
    name: "Sharon Farrell",
    location: "Blackpool",
    quote:
      "Needed an electrician fast due to no power. Even though the lad had finished for the day it was late, he came out and fixed my problem with a smile. A very charming young man and very reasonable price. Would highly recommend.",
  },
];

export const Testimonials = () => {
  const [api, setApi] = useState<CarouselApi>();

  return (
    <section id="reviews" className="scroll-mt-20 bg-secondary/30 py-20">
      <div className="mx-auto max-w-360 px-4 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold tracking-wider text-primary uppercase">
            Reviews
          </span>
          <h2 className="mt-2 text-3xl font-bold sm:text-4xl">
            What Our Customers Say
          </h2>
          <p className="mt-4 text-muted-foreground">
            We're proud of the reputation we've built, one job at a time.
          </p>
        </div>
        <Carousel opts={{ align: "start", loop: true }} setApi={setApi} className="mt-12">
          <CarouselContent>
            {testimonials.map((testimonial) => (
              <CarouselItem
                key={testimonial.name}
                className="sm:basis-1/2 lg:basis-1/3"
              >
                <Card className="h-full border-white/10">
                  <CardHeader>
                    <Quote className="size-8 text-primary/40" />
                    <div className="flex gap-0.5">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <Star key={i} className="size-4 fill-primary text-primary" />
                      ))}
                    </div>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground">
                      "{testimonial.quote}"
                    </p>
                    <p className="mt-4 font-semibold">{testimonial.name}</p>
                    <p className="text-xs text-muted-foreground">{testimonial.location}</p>
                  </CardContent>
                </Card>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
        <div className="mt-6 flex justify-center gap-3">
          <Button variant="outline" size="icon" onClick={() => api?.scrollPrev()}>
            <ArrowLeft />
            <span className="sr-only">Previous testimonial</span>
          </Button>
          <Button variant="outline" size="icon" onClick={() => api?.scrollNext()}>
            <ArrowRight />
            <span className="sr-only">Next testimonial</span>
          </Button>
        </div>
      </div>
    </section>
  );
};
